import { render } from "./MyPageReviewList.vue?vue&type=template&id=161f2582"
import script from "./MyPageReviewList.vue?vue&type=script&lang=js"
export * from "./MyPageReviewList.vue?vue&type=script&lang=js"

import "./MyPageReviewList.vue?vue&type=style&index=0&id=161f2582&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__